export const REQUEST_ERROR = 'REQUEST_ERROR'
export const ROUTE_BACK = 'ROUTE_BACK'
export const REQUEST_STATUS = 'REQUEST_STATUS'

export interface IRouteBackState {
    url: string
    param: string
    state: any
}
export interface IRequestState {
    fetching: boolean
}
export interface IRequestErrorState {
    fetching: boolean
    message: string
}

export interface IRouteBackAction {
    type: typeof ROUTE_BACK
    payload: IRouteBackState
}
export interface IRequestStatusAction {
    type: typeof REQUEST_STATUS
    payload: IRequestState
}
export interface IRequestFailAction {
    type: typeof REQUEST_ERROR
    payload: IRequestErrorState
}

export const requestStatus = (status: boolean): IRequestStatusAction => ({
    type: REQUEST_STATUS,
    payload: {
        fetching: status,
    }
})
export const requestFail = (message: string): IRequestFailAction => ({
    type: REQUEST_ERROR,
    payload: {
        fetching: false,
        message
    }
})
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const routeBack = (url: string, param: string, state: any): IRouteBackAction => ({
    type: ROUTE_BACK,
    payload: {
        url,
        param,
        state
    }
})

export type CommonUnionType =
    | IRequestStatusAction
    | IRequestFailAction
    | IRouteBackAction